import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';

import { FilterField, Filters } from './filters/filter';
import { SavedFilter } from './filter.service';
import { TabbedFilterField } from './filters/tabbed/filter-field-tabbed';

@Component({
  selector: 'va-filter',
  template: `
    <div class="filters">
      <div class="title">
        <div class="title-text">{{ '' + filters.title | translate }}</div>
        @if (savedFilters) {
          <uikit-saved-filters-menu
            [showFilterSharing]="showFilterSharing"
            [options]="savedFilters"
            (selection)="savedFilterSelected.emit($event)"
            (saveCurrentFilter)="saveCurrentFilter.emit($event)"
            (removeSavedFilter)="removeSavedFilter.emit($event)"
            (exportFilterDialog)="exportFilterDialog.emit($event)"
            (importFilterDialog)="importFilterDialog.emit($event)"
            />
        }
      </div>
      @for (section of filters.sections; track section) {
        <div>
          @if (!section.hideSelectors) {
            <div
            [ngClass]="{
              'subtitle-uncollapsed': !section.collapsed,
              'subtitle-collapsed': section.collapsed,
              'list-item-subtitle': true,
            }"
              (click)="section.toggleCollapsed()"
              >
              @if (section.title) {
                <p class="section-title">{{ '' + section.title | translate }}</p>
              }
              @if (section.collapsed) {
                <i class="material-icons arrow">keyboard_arrow_right</i>
              }
              @if (!section.collapsed) {
                <i class="material-icons arrow">keyboard_arrow_down</i>
              }
            </div>
            <div [ngClass]="{ 'list-item-uncollapsed': !section.collapsed, 'list-item-collapsed': section.collapsed }">
              @for (field of getDisplayableFields(section.fields); track field) {
                <div class="list-item">
                  <ng-container filter (filterApplied)="fieldValueChanged.emit($event)" [filterField]="field" />
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
    `,
  styleUrls: ['filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FilterComponent {
  @Input() showFilterSharing? = false;
  @Input() filters: Filters;
  @Input() savedFilters: Observable<SavedFilter[]>;
  @Output() fieldValueChanged = new EventEmitter();
  @Output() savedFilterSelected = new EventEmitter();
  @Output() saveCurrentFilter = new EventEmitter();
  @Output() removeSavedFilter = new EventEmitter();
  @Output() exportFilterDialog = new EventEmitter();
  @Output() importFilterDialog = new EventEmitter();

  getDisplayableFields(fields: FilterField<any>[]): FilterField<any>[] {
    return fields.filter((field: FilterField<any>) => {
      return !(field instanceof TabbedFilterField);
    });
  }
}
